<template>
  <!-- doesn't feel like the transition is doing anthing, but keep it as is for now -->
  <v-skeleton-loader
    transition="scale-transition"
    v-if="loading"
    type="card"
    class="option-box ma-3"
  >
  </v-skeleton-loader>
  <v-card
    v-else
    flat
    hover
    color="#F2F2F2"
    class="option-box text-center pa-6 ma-3"
  >
    <div class="icon-container ma-4">
      <v-icon v-bind="extraIconProps">
        {{ icon }}
      </v-icon>
    </div>
    <div class="link-text mb-2">{{ title }}</div>
    <div class="description-text">
      {{ description }}
    </div>
  </v-card>
</template>

<script>
export default {
  name: "OptionCard",
  props: ["icon", "description", "title", "loading"],
  computed: {
    extraIconProps() {
      if (this.icon.startsWith("mdi")) {
        return {
          size: 48
        };
      }
      return null;
    }
  }
};
</script>

<style lang="sass" scoped>
.option-box
  width: 270px
  border-radius: 10px !important
  &.selected
    border: 3px solid rgba($primary, .5) !important

.icon-container
  height: 70px
  display: flex
  justify-content: center
  align-items: flex-end

.link-text
  color: $link-color
  font-size: 20px
  line-height: 25px
  text-decoration: underline
  font-weight: 600
</style>
